import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { UserPreferencesStorage } from './user-preferences-storage';

@NgModule({
    imports: [
        CommonModule,
        HttpClientModule,
    ],
    providers: [
        UserPreferencesStorage,
    ],
})
export class UserPreferencesModule { }
